import { cn } from '@/lib/utils'

/** Segnaposto di un blocco in arrivo (variante notte); pulsa solo se il movimento è consentito, altrimenti resta fermo. */
export function Skeleton({ className }: { className?: string }) {
  return <div aria-hidden="true" className={cn('rounded-xl bg-paper/[0.07] motion-safe:animate-pulse', className)} />
}

/** Palinsesto in arrivo: le schede delle partite al loro posto, in griglia come quelle vere. */
export function MarketsSkeleton() {
  return (
    <div data-testid="sb-markets-skeleton" className="space-y-3">
      <Skeleton className="h-6 w-40" />
      <div className="grid grid-cols-1 gap-2 lg:grid-cols-2">
        {Array.from({ length: 6 }, (_, i) => <Skeleton key={i} className="h-32" />)}
      </div>
    </div>
  )
}

/** Antepost in arrivo: l'avviso e i tre mercati al loro posto, a caselle come quelli veri. */
export function OutrightsSkeleton() {
  return (
    <div data-testid="sb-outrights-skeleton" className="space-y-3">
      <Skeleton className="h-12" />
      {Array.from({ length: 3 }, (_, i) => (
        <div key={i} className="space-y-2 rounded-xl border border-paper/12 p-3">
          <Skeleton className="h-4 w-40" />
          <div className="grid grid-cols-1 gap-1.5 min-[420px]:grid-cols-2">
            {Array.from({ length: 4 }, (_, j) => <Skeleton key={j} className="h-12" />)}
          </div>
        </div>
      ))}
    </div>
  )
}
